export class ProductContact {
}
//# sourceMappingURL=product-contact.js.map